import React, { Component } from 'react';
import { connect } from 'react-redux';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconActionDeleteBlue from '../../../assets/icons/IconActionDeleteBlue';
import IconAddTransparent from '../../../assets/icons/IconAddTransparent';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_DELETE,
    MASTER_DATA_REMARK_INSERT,
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class ClosedTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, closedTicketDataSelectedEdit: data, closedTicket: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_DELETE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btndelete" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showConfirmDeleteAlert: true, closedTicketDataSelectedDelete: data })}>
                                    <IconActionDeleteBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listClosedTicket: [],
            closedTicket: '',
            closedTicketDataSelectedEdit: {},
            closedTicketDataSelectedDelete: {},
            showWarningClosedTicket: false,
            showPopupInfo: false,
            showAddModal: false,
            showEditModal: false,
            showConfirmAddAlert: false,
            showSuccessAddAlert: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showConfirmDeleteAlert: false,
            showSuccessDeleteAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateClosedTicket();
                this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateClosedTicket();
                this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    getInitiateClosedTicket = () => {
        API_REMARK.getInitiateClosedTicket(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListClosedTicket = (current, pageSize) => {
        API_REMARK.getListClosedTicket(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listClosedTicket: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningClosedTicket: false,
            closedTicket: ''
        });
    }

    handleConfirmAddClosedTicket = () => {
        if (!this.state.closedTicket) return this.setState({ showWarningClosedTicket: true });
        this.setState({ showConfirmAddAlert: true });
    }

    handleAddClosedTicket = () => {
        const data = {
            description: this.state.closedTicket,
            category: 'remark-close-ticket'
        }

        API_REMARK.postDataRemark(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showAddModal: false,
                        showConfirmAddAlert: false,
                        showSuccessAddAlert: true,
                        closedTicket: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmAddAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessAddClosedTicket = () => {
        this.setState({
            showSuccessAddAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateClosedTicket();
            this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleConfirmEditClosedTicket = () => {
        if (!this.state.closedTicket) return this.setState({ showWarningClosedTicket: true });
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditClosedTicket = () => {
        const closedTicketId = this.state.closedTicketDataSelectedEdit.id;
        const data = {
            remark: this.state.closedTicketDataSelectedEdit.remark,
            description: this.state.closedTicket,
            category: 'remark-close-ticket',
            category_id: this.state.closedTicketDataSelectedEdit.category_id,
            updated_at: this.state.closedTicketDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(closedTicketId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        closedTicket: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditClosedTicket = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateClosedTicket();
            this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    handleDeleteClosedTicket = () => {
        this.setState({ showConfirmDeleteAlert: false });

        const closedTicketId = this.state.closedTicketDataSelectedDelete.id;
        const data = {
            remark: this.state.closedTicketDataSelectedDelete.remark,
            category: 'remark-close-ticket',
            updated_at: this.state.closedTicketDataSelectedDelete.updated_at
        }
        API_REMARK.deleteDataRemark(closedTicketId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({ showSuccessDeleteAlert: true });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessDeleteClosedTicket = () => {
        this.setState({
            showSuccessDeleteAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateClosedTicket();
            this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateClosedTicket();
        this.getListClosedTicket(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Closed Tiket"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Closed Ticket Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-max top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Keterangan Closed Tiket digunakan untuk penentuan list dropdown yang akan ditampilkan</p>
                                                <p>pada saat melakukan Closed Tiket sesuai dengan Keterangan Closed Tiket yang dipilih.</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Add Closed Ticket Button */}
                                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnaddclosedticket" onClick={() => this.setState({ showAddModal: true })} className="flex items-center text-white py-2 px-6 rounded-md bg-nexcaredefault cursor-pointer">
                                            <IconAddTransparent />
                                            <span className="ml-2">Closed Ticket</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                {/* Table Closed Ticket */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listClosedTicket}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Add Closed Ticket Modal */}
                    <div className={this.state.showAddModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Tambah Closed Ticket</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlclosedticketadd"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="closedTicket"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningClosedTicket: false });
                                        }}
                                        minLength="3"
                                        maxLength="50"
                                        autoComplete="off"
                                        value={this.state.closedTicket}
                                    />
                                    {this.state.showWarningClosedTicket && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btnaddclosedticket" onClick={this.handleConfirmAddClosedTicket}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Edit Closed Ticket Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/4">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Closed Ticket</p>
                                <div>
                                    <p className="text-nexcareblack2 text-sm font-medium mb-1">Deskripsi Remark <Mandatory /></p>
                                    <textarea
                                        id="tmlclosedticketedit"
                                        className="form-control resize-none"
                                        placeholder="Tulis Deskripsi Remark"
                                        name="closedTicket"
                                        onChange={e => {
                                            this.handleChange(e);
                                            this.setState({ showWarningClosedTicket: false });
                                        }}
                                        minLength="3"
                                        maxLength="50"
                                        autoComplete="off"
                                        value={this.state.closedTicket}
                                    />
                                    {this.state.showWarningClosedTicket && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditclosedticket" onClick={this.handleConfirmEditClosedTicket}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmAddAlert} button title="Simpan Closed Ticket" desc="Apakah Anda yakin ingin menyimpan data?" close={() => this.setState({ showConfirmAddAlert: false })} submit={this.handleAddClosedTicket} />
                    <Alert show={this.state.showSuccessAddAlert} icon="success" title="Berhasil" desc="Data berhasil disimpan" close={this.handleSuccessAddClosedTicket} ok />
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Closed Ticket" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditClosedTicket} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditClosedTicket} ok />
                    <Alert show={this.state.showConfirmDeleteAlert} button title="Hapus Closed Ticket" desc="Apakah Anda yakin ingin menghapus data?" close={() => this.setState({ showConfirmDeleteAlert: false, closedTicketDataSelectedDelete: {} })} submit={this.handleDeleteClosedTicket} />
                    <Alert show={this.state.showSuccessDeleteAlert} icon="success" title="Berhasil" desc="Data berhasil dihapus" close={this.handleSuccessDeleteClosedTicket} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClosedTicket);